import * as React from 'react'
import { Table } from 'semantic-ui-react'

interface ProfileHistoryProps {
  history: string[][]
  style?: React.CSSProperties
}

export default class ProfileHistoryMol extends React.Component<
  ProfileHistoryProps,
  {}
> {
  render() {
    return (
      <div style={{ ...this.props.style }}>
        <Table celled>
          <Table.Body>
            {this.props.history.map(item => (
              <Table.Row key={item[0]}>
                <Table.Cell>{item[0]}</Table.Cell>
                <Table.Cell>{item[1]}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
    )
  }
}
